<template>
  <div class="company--contacts-tab animated fadeIn">
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i>
            Contacts List
            <div class="pull-right tools">
              <b-button variant="primary" size="sm" @click="onSendEmail" :disabled="checkedContacts.length == 0">
                Send Email
              </b-button>
              <edit-contact :companyId="companyId" ref="editModal" v-on:change="getContacts(searchQuery)"></edit-contact>
              <button type="button" class="btn btn-secondary btn-sm d-inline ml-1" @click="exportList" :disabled="!exportEnabled">
                <i class="fa fa-download"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <b-row class="search justify-content-between">
              <b-col cols="4">
                <b-form-input
                  size="sm"
                  class="mr-sm-2"
                  placeholder="Search by name"
                  left
                  v-model="searchQuery"
                  @input="onSearch"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
          <grid-component
            isResizable
            isReorderable
            :gridId="gridId"
            :itemData="contactsList"
            :fields="fields"
            :onEdit="openDetails"
            :onDelete="deleteContact"
            :checkBoxValues="checkedContacts"
            @checkedItem="checkedContacts=$event"
          />
        </div>
      </b-col>
    </b-row>
    <send-emails :sendEmailData="sendEmailData" @refresh="afterEmailSent" hideAttachments></send-emails>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'lodash';

import { GRID_ID, GRID_PAGE_SIZES, PAGE_SIZE, SAVE_SETTINGS_DELAY } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import contactService from '@/resources/ContactService';
import GridComponent from '@/shared/components/GridComponent';
import SendEmails from '@/shared/components/SendEmails/index';
import contactsFields from '../../fields';
import EditContact from '../EditContact/index';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    EditContact,
    GridSettings,
    GridComponent,
    SendEmails
  },
  metaInfo: () => ({
    title: 'Contacts',
  }),
  data() {
    return {
      prepareColumnsData,
      searchQuery: '',
      fields: contactsFields,
      gridId: GRID_ID.CONTACT,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      checkedContacts: [],
      sendEmailData: {}
    };
  },
  computed: {
    ...mapGetters('contacts', {
      contactsList: 'contacts',
    }),
    ...mapGetters('account', ['gridSettingsById']),
    emptyMessage: function() {
      return this.searchQuery ? `No contact <span class="text-primary">${this.searchQuery}</span> found` : 'No contacts found';
    },
    companyId() {
      return this.$route.params.id;
    },
    exportEnabled() {
      return this.contactsList && this.contactsList.length;
    },
    gridSettings() {
      return this.gridSettingsById(GRID_ID.CONTACT);
    },
    checkedContactEmails() {
      return this.contactsList.filter(x => this.checkedContacts.includes(x.id)).map(x => x.email1);
    }
  },
  methods: {
    ...mapActions('contacts', [
      'getAllContacts',
      'getContactsByCompany'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    async getContacts(searchQuery) {
      // await this.getAllContacts({
      //   accountId: this.companyId,
      //   searchQuery: searchQuery,
      // });
      await this.getContactsByCompany({companyId: this.companyId, searchQuery: searchQuery});
    },
    onSearch: debounce(async function () {
      this.getContacts(this.searchQuery);
    }, SEARCH_DEBOUNCE_TIME),
    async deleteContact(contact) {
      const deleteConfirmed = await this.openConfirmBox({message:`Are you sure you want to delete "${contact.firstName} ${contact.lastName}"?`});
      if (deleteConfirmed) {
        await contactService.deleteContact(contact.id);
        this.getContacts(this.searchQuery);
      }
    },
    openDetails(row) {
      this.$router.push({
        name: 'company.contact.details',
        params: { contactId: row.id },
      });
    },
    exportList() {
      if (this.exportEnabled) {
        contactService.exportList(this.companyId, this.searchQuery);
      }
    },
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: contactsFields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: GRID_ID.CONTACT,
        settings: { columns: newColumns },
      });
    }, SAVE_SETTINGS_DELAY),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: contactsFields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: GRID_ID.CONTACT,
        settings: { columns: newColumns },
      });
    },
    onSendEmail() {
      
      if (this.checkedContactEmails.length > 0) {
        this.sendEmailData = {
          source: 'Contacts',
          to: this.checkedContactEmails.join('; '),
          ReferenceId: 0
        }
        console.log(this.sendEmailData, "SEnd Email Data page")
        this.$root.$emit('bv::show::modal', 'send-email-modal');
      }
      
    },
    afterEmailSent() {
      this.checkedContacts = [];
    }
  },
  async mounted() {
    this.getContacts('');
  },
};
</script>

<style lang="scss">
.company--contacts-tab {
  .tools > * {
    margin: 0 0 0 3px;
  }
  table td {
    cursor: pointer;
    white-space: nowrap;
  }
  .grid {
    max-height: 450px;
  }
}

</style>
